Date.prototype.yyyymm = function() {
    var mm = this.getMonth() + 1;

    return isNaN(mm) ? '' : [this.getFullYear(),
        (mm>9 ? '' : '0') + mm
        ].join('-');
};

Date.prototype.yyyymmdd = function() {
    // Robust formatting that avoids off-by-one both when:
    // 1) Date was created from a date-only ISO string (UTC midnight)
    // 2) Date is a local time (e.g., now()) possibly near timezone boundaries
    if (isNaN(this.getTime())) return '';

    var isUTCDateOnly = this.getUTCHours() === 0 && this.getUTCMinutes() === 0 && this.getUTCSeconds() === 0 && this.getUTCMilliseconds() === 0 &&
                        !(this.getHours() === 0 && this.getMinutes() === 0 && this.getSeconds() === 0 && this.getMilliseconds() === 0);

    var yyyy, mm, dd;
    if (isUTCDateOnly) {
        yyyy = this.getUTCFullYear();
        mm = this.getUTCMonth() + 1;
        dd = this.getUTCDate();
    } else {
        yyyy = this.getFullYear();
        mm = this.getMonth() + 1;
        dd = this.getDate();
    }

    return [
        yyyy,
        (mm>9 ? '' : '0') + mm,
        (dd>9 ? '' : '0') + dd
    ].join('-');
};

Date.prototype.ddmmyyyy = function() {
    // Mirror the robust behavior from yyyymmdd to avoid off-by-one
    if (isNaN(this.getTime())) return '';

    var isUTCDateOnly = this.getUTCHours() === 0 && this.getUTCMinutes() === 0 && this.getUTCSeconds() === 0 && this.getUTCMilliseconds() === 0 &&
                        !(this.getHours() === 0 && this.getMinutes() === 0 && this.getSeconds() === 0 && this.getMilliseconds() === 0);

    var yyyy, mm, dd;
    if (isUTCDateOnly) {
        yyyy = this.getUTCFullYear();
        mm = this.getUTCMonth() + 1;
        dd = this.getUTCDate();
    } else {
        yyyy = this.getFullYear();
        mm = this.getMonth() + 1;
        dd = this.getDate();
    }

    return [
        (dd>9 ? '' : '0') + dd,
        (mm>9 ? '' : '0') + mm,
        yyyy
    ].join('/');
};

Date.prototype.mmyyyy = function() {
    var mm = this.getMonth() + 1;
    
    return isNaN(mm) ? '' : [(mm>9 ? '' : '0') + mm, 
    this.getFullYear()].join('/');
};

Date.prototype.timeddmmyyyy = function() {
    var mm = this.getMonth() + 1;
    var dd = this.getDate();
    var hour = this.getHours();
    var minutes = this.getMinutes();
    var seconds = this.getSeconds();

    return isNaN(mm) ? '' : [(dd>9 ? '' : '0') + dd,
        (mm>9 ? '' : '0') + mm,
        this.getFullYear()
        ].join('/') + ' ' + hour + ':' + minutes + ':' + seconds;
};

Number.prototype.toMoeda = function(comCifra = false) {
    let numero = this.toFixed(2).split('.');
    let cifra = comCifra ? "R$ " : "";
    numero[0] = cifra + numero[0].split(/(?=(?:...)*$)/).join('.');

    return isNaN(this) ? 0 : numero.join(',');
};

Number.prototype.toPercentual = function() {
    let numero = this.toFixed(2).split('.');
    numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
    
    return isNaN(this) ? 0 : numero.join(',') + ' %';
};

Boolean.prototype.toSimNao = function() {
    return this == true ? 'Sim' : 'Não';
}

export default function JSONToCSVConverter(JSONData, ReportTitle, ShowLabel){

    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    var CSV = '';
 
    //CSV += ReportTitle + '\r\n\n';
 
    if (ShowLabel) {
        var row = "";
 
        for (var index in arrData[0]) {
 
            row += index + ';';
        }
 
        row = row.slice(0, -1);
 
        CSV += row + '\r\n';
    }
 
    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
        var row = "";
 
        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
            // console.log([i].toString()+[index].toString(), arrData[i][index])
            row += (arrData[i][index] == null || arrData[i][index] == "") ? ';' : (arrData[i][index]).toString().replace(/[\n\r]+/g, '') + ';';
        }
 
        row.slice(0, row.length - 1);
 
        CSV += row + '\r\n';
    }
 
    if (CSV == '') {
        alert("Invalid data");
        return;
    }
 
    var fileName = "Excel_";
 
    fileName += ReportTitle.replace(/ /g,"_");
 
    //csv or xls
    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
 
    var link = document.createElement("a");
    link.href = uri;
 
    
    //link.style = "visibility:hidden";
    link.download = fileName + ".csv";
 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function TableToExcel(table, worksheet) {
    const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/></head><body>{table}</body></html>'
        , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
      
    if (!table.nodeType) {
        table = document.getElementById(table).querySelectorAll('div')[0];
    }

    const ctx = {worksheet: worksheet || 'Resultado', table: table.innerHTML};
    const blob = new Blob(['\ufeff', format(template, ctx)], {type: 'application/vnd.ms-excel;charset=UTF-8'});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = `${ctx.worksheet}.xls`;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
